<template>
  <div class="page-container md-layout-row">
    <md-button class="md-icon-button" @click="toggleMenu">
      <md-icon>menu</md-icon>
    </md-button>
    <md-app>
      <md-app-drawer :md-active.sync="menuVisible" md-persistent="full">
        <md-list>
          <md-list-item to="/dummy/inputs">
            <md-icon>move_to_inbox</md-icon>
            <span>Inputs </span>
          </md-list-item>
          <md-list-item to="/dummy/inputs">
            <md-icon>move_to_inbox</md-icon>
            <span>Inputs </span>
          </md-list-item>
        </md-list>
      </md-app-drawer>
      <md-app-content>
        <router-view></router-view>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuVisible: false,
    }
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
  },
}
</script>

<style lang="scss"></style>
